<template>
    <!-- Page Content Wrapper -->
    <div v-if="permissionsArray.includes('manage_audit_inventory')" id="page-content-wrapper" class="admin-content-area dashboard">
        <div class="container-fluid xyz location-listing">
            <div class="page-header-top-container" style="position: fixed;">
                <div class="page-name mb-1">Audit Inventory List</div>
                <!-- <div class="page-name" style="width:100%">
                    <div class="row">
                        <div class="col-md-6">
                            <VueCtkDateTimePicker v-model="date_picker_dates"
                                range
                                :only-date="date_picker_options.onlyDate"
                                :only-time="false"
                                :output-format="date_picker_options.outputFormat"
                                :format="date_picker_options.inputFormat"
                                :formatted="date_picker_options.formatted"
                                :noClearButton="date_picker_options.noClearButton"
                                :custom-shortcuts="date_picker_options.customShortcuts"
                                @input="changeDatePickerDate()"
                                :maxDate="date_picker_options.maxDate"
                            ></VueCtkDateTimePicker>
                        </div>
                        <div class="col-md-6"> -->
                            <!-- <button type="submit" v-on:click.prevent="loadAuditInventory(true)" class="btn btn-primary waves-effect pull-right">Export</button>
                            <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="loadAuditInventory(false)">Apply Filter</button>
                            <button type="button" class="btn btn-primary waves-effect pull-right" v-on:click="clearFilter()">Clear Filter</button> -->
                            <button type="submit" id='refreshList' title='Refresh' class="extraFeature btn btn-primary waves-effect pull-right ml-2" v-on:click.prevent="loadAuditInventory(false)">
                                <i class="fa fa-rotate-right" aria-hidden="true"></i>
                            </button>
                        <!-- </div>
                    </div>
        		</div> -->
            </div>

            <!--page content-->
            <div class="admin-page-content" style="padding-top: 120px;">
                <div class="app-filter-good-table-container text-align-placeholder-user-admin-audit-inventory-list">
                    <vue-good-table
                        ref="listAuditInventory"
                        mode="remote"
                        title="Audit Inventory"
                        @on-page-change="onPageChange"
                        @on-column-filter="onColumnFilter"
                        @on-per-page-change="onPerPageChange"
                        @on-sort-change="onSortChange"
                        :totalRows="totalRecords"
                        :columns="columns"
                        :rows="rows"
                        :pagination-options="{
                            enabled: true,
                            mode: 'pages',
                            pageLabel: 'Page',
                            position: 'both',
                            perPage: serverParams.perPage,
                            setCurrentPage: serverParams.setCurrentPage,
                            perPageDropdown: [25, 50, 100, 200 ,500],
                            dropdownAllowAll: false,
                        }"
                        :search-options="{
                            enabled: false,
                        }">

                        <!-- Custome Pagination -->
                        <template slot="pagination-top" slot-scope="props">
                            <div class="vgt-wrap__footer top-pagination crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                            v-model="serverParams.perPage"
                                            @change="changedValueTask"
                                            @input="changedValueTaskCustomPerPageTask()"
                                            name="customPerPage"
                                            id="customPerPage"
                                            label="text"
                                            :clearable="false"
                                            :searchable="false"
                                            :filterable="false"
                                            :options="serverParams.perPageDropdown"
                                            placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <!-- Custome Pagination -->
                        <template slot="pagination-bottom" slot-scope="props">
                            <div class="vgt-wrap__footer crm">
                                <div  class="row">
                                    <div class="col-sm-12 col-md-2 PerPage">
                                        <v-select title="Select Per Page"
                                                v-model="serverParams.perPage"
                                                @change="changedValueTask"
                                                @input="changedValueTaskCustomPerPageTask()"
                                                name="customPerPage"
                                                id="customPerPage"
                                                label="text"
                                                :clearable="false"
                                                :searchable="false"
                                                :filterable="false"
                                                :options="serverParams.perPageDropdown"
                                                placeholder="Select Per Page">
                                        </v-select>
                                    </div>
                                    <div class="mt-2 col-sm-12 col-md-2 RowsDisplay">
                                        <p class="pageRowCount">{{paginationDisplayRowsTask}} of {{totalRecords}}</p>
                                    </div>
                                    <div class="col-sm-12 col-md-6 Pagination">
                                        <ul class="pagination">
                                            <li class="FirstPage" title="First Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(1)" class="page-link" href="javascript:void(0)">1</a>
                                                </template>
                                            </li>
                                            <li class="page-item PreviousPage" title="Previous Page">
                                                <template v-if="Number(serverParams.page) == 1">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1"><i class="fa fa-angle-left"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1" v-on:click="onPerticularPageClickTask(Number(serverParams.page)-1)" ><i class="fa fa-angle-left"></i></a>
                                                </template>
                                            </li>
                                            <!--New Implementation-->
                                            <template v-if="pageNumberListTask() < displayPageTask">
                                                <template v-for="(n, index) in pageNumberListTask()">
                                                    <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                    <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                        <a class="page-link" href="javascript:void(0)">
                                                            {{n}}
                                                        </a>
                                                    </li>
                                                </template>
                                            </template>
                                            <template v-else>
                                                <!--End New Implementation-->
                                                <template v-if="Number(serverParams.page) <= pageCompareTask">
                                                    <template v-for="(n, index) in displayPageTask">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                                <template v-else-if="Number(serverParams.page) >= (pageNumberListTask() - (pageCompareTask-1))">
                                                    <template v-for="(n, index) in pageNumberListTask()">
                                                        <template v-if="n > (pageNumberListTask() - displayPageTask)">
                                                            <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                            <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                                <a class="page-link" href="javascript:void(0)">
                                                                    {{n}}
                                                                </a>
                                                            </li>
                                                        </template>
                                                    </template>
                                                </template>
                                                <template v-else>
                                                    <template v-for="(n, index) in pageNumberListTask()" v-if="(n >= (Number(serverParams.page) - (pageCompareTask -1))) && (n <= (Number(serverParams.page) + (pageCompareTask -1)))">
                                                        <li :title="'Page ' +n" class="PagesClass page-item active" v-bind:id="'pageNumber' + n" v-if="n == Number(serverParams.page)">
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                        <li :title="'Page ' +n" v-on:click="onPerticularPageClickTask(n)" class="PagesClass page-item" v-bind:id="'pageNumber' + n" v-else>
                                                            <a class="page-link" href="javascript:void(0)">
                                                                {{n}}
                                                            </a>
                                                        </li>
                                                    </template>
                                                </template>
                                            </template>
                                            <li class="page-item NextPage" title="Next Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                                <template v-else>
                                                    <a class="page-link" href="javascript:void(0)" v-on:click="onPerticularPageClickTask(Number(serverParams.page)+1)"><i class="fa fa-angle-right"></i></a>
                                                </template>
                                            </li>
                                            <li class="LastPage" title="Last Page">
                                                <template v-if="Number(serverParams.page) == pageNumberListTask()">
                                                    <a class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                                <template v-else>
                                                    <a v-on:click="onPerticularPageClickTask(pageNumberListTask())" class="page-link" href="javascript:void(0)" tabindex="-1">{{pageNumberListTask()}}</a>
                                                </template>
                                            </li>
                                        </ul>
                                    </div>
                                    <div class="mt-2 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <p class="pageJumpLabel">Page : </p>
                                    </div>
                                    <div class="mt-1 col-lg-1 col-md-1 col-sm-2 col-xs-6">
                                        <input @keyup.enter="jumpToPageInTask" v-model="jumpToPageTask" type="text" class="form-control form-control-sm" name="jumpToPageTask" id="jumpToPageTask" placeholder="Page">
                                    </div>
                                </div>
                            </div>
                        </template>
                        <!-- End Custome Pagination -->

                        <template slot="table-row" slot-scope="props" v-for="(row,key) in rows">
                            <div :key="key">
                                <div v-if="props.column.field == 'action'">
                                    <router-link class="btn edit-btn-vvg waves-effect" title="Detail Audit Inventory" v-bind:to="{name: 'DateWiseAuditInventory',params:{customerId:props.row.customer_id}}">
                                        <i class="fa fa-list" aria-hidden="true"></i>
                                    </router-link>
                                </div>
                                <div v-else>{{props.formattedRow[props.column.field]}}</div>
                            </div>
                        </template>
                        <div slot="selected-row-actions" slot-scope="computed">
                            {{computed.selectedRows}}
                        </div>
                    </vue-good-table>
                </div>
            </div>
            <!--page content-->
        </div>
        <app-footer></app-footer>
    </div>
    <div v-else>
        <no-permission></no-permission>
    </div>
    <!-- Page Content Wrapper -->
</template>

<script>
    var self;
    import Vue from "vue";
    import Footer from "@/components/partials/Footer";
    import EventBus from ".././event-bus";
    import { commonMixins } from "../../mixins/commonMixins";
    import { HTTP } from "../../http-common.js";
    import VueGoodTable from "vue-good-table";
    import NoAccessPermission from '../NoAccessPermission';
    import vSelect from 'vue-select';
    import moment from 'moment';
    import timezone from 'moment-timezone';

    Vue.use(VueGoodTable);
    export default {
        name: "ListAuditInventory",
        components: {
            "app-footer": Footer,
            "no-permission" : NoAccessPermission,
            'v-select': vSelect,
        },
        mixins: [commonMixins],
        data() {
            return {
                permissionsArray : ['manage_audit_inventory'],
                roleId: 0,
                firstLoad: 0,
                columns: [
                    /* {
                        label: "User Name",
                        field: "user_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "User Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    {
                        label: "Customer Name",
                        field: "customer_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Customer Name", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    {
                        // label: "Last Audit End Date",
                        label: "Audit Completion Date",
                        field: "audit_close_date_time",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "MM/DD/YYYY", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    },
                    /* {
                        label: "Inventory",
                        field: "inventory_name",
                        filterable: true,
                        filterOptions: {
                            enabled: true, // enable filter for this column
                            placeholder: "Inventory", // placeholder for filter input
                            filterValue: "", // initial populated value for this filter
                            filterDropdownItems: [], // dropdown (with selected values) instead of text input
                            filterFn: this.onColumnFilter, //custom filter function that
                            trigger: "enter" //only trigger on enter not on keyup
                        }
                    }, */
                    /* {
                        label: "Discrepancy Part Count",
                        field: "discrepancy_part_count",
                        sortable: false,
                        thClass: "disable-sorting",
                        type: "number",
                    }, */
                    /* {
                        label: "Date",
                        field: "updated_at",
                        sortable: false,
                        thClass: "disable-sorting",
                    }, */
                    {
                        label: "Actions",
                        field: "action",
                        html: true,
                        sortable: false,
                        thClass: "disable-sorting"
                    }
                ],
                rows: [],
                totalRecords: 0,
                serverParams: {
                    columnFilters: {},
                    page: 1,
                    perPage: 'All',
                    sort: {
                        field: "id",
                        type: "desc"
                        /* field: "audit_close_date_time",
                        type: "asc" */
                    },
                    perPageDropdown : [],
                },
                recordsCounts: "",
                selectedRows: 0,

                displayPageTask: 7,
                jumpToPageTask: 0,
                pageCompareTask: 0,
                paginationDisplayRowsTask: '',
                loginUserId : 0,
                date_picker_dates: "",
                date_picker_options: {
					range: true,
					onlyDate: true,
					outputFormat: 'YYYY-MM-DD',
					inputFormat: 'YYYY-MM-DD',
					formatted: 'MMM DD, YYYY',//'YYYY-MM-DD', 
					noClearButton: true,
					maxDate : '',
					// Getting error when using the for date picker options
					// 'no-shortcuts': false,
					customShortcuts : [
						{ key: 'yesterday', label: 'Yesterday', value: '-day', isSelected: true },
						{ key: 'thisWeek', label: 'This Week', value: 'isoWeek', isSelected: false },
						{ key: 'lastWeek', label: 'Last Week', value: '-isoWeek', isSelected: false },
						{ key: 'thisMonth', label: 'This Month', value: 'month', isSelected: false },
						{ key: 'lastMonth', label: 'Last Month', value: '-month', isSelected: false },
                        {
                            key: 'customValue',
                            label: 'YTD',
                            value: () => {
                                return {
                                    start: moment().startOf('year'),
                                    end: moment()
                                }
                            },
                            callback: ({ start, end }) => {
                                // console.log('My shortcut was clicked with values: ', start, end)
                            }
                        },
					]
                },
            };
        },
        beforeMount: function() {
            self = this;
            EventBus.$emit("menu-selection-changed", "audit-inventory");
        },
        mounted: function() {
            var dateObject = self.loadAllFilter('adminAuditDate', 'AdminAuditList');
            self.loadFilters('adminauditlist', self.columns, self.serverParams, 'AdminAuditList');

            //self.getUserRole();
            self.getUserPermissions();
            if(typeof(dateObject) != 'undefined' && dateObject != '') {
                console.log(dateObject);
                self.date_picker_dates = dateObject;
            } else {
                self.date_picker_dates = {
                    "start": moment().subtract(13, 'days'),
                    "end": moment()
                };
            }
            self.windowWidth = $(window).width();
            $(window).resize(function () {
                self.windowWidth = $(window).width();
                /* if (self.windowWidth > 767) {
                    $('.contacttDetails').hide();
                } else {
                    $('.contacttDetails').show();
                } */
                // $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 360);
            });
            this.jumpToPageTask = this.serverParams.page;
            this.pageCompareTask = Math.ceil(this.displayPageTask / 2);
            $("#jumpToPageTask").on('keyup', function (e) {
                if (e.keyCode === 13) {  //checks whether the pressed key is "Enter"
                    self.jumpToInputPageTask(self.jumpToPageTask)
                }
            });

            this.serverParams.perPageDropdown.push(25);
            this.serverParams.perPageDropdown.push(50);
            this.serverParams.perPageDropdown.push(100);
            this.serverParams.perPageDropdown.push(200);
            this.serverParams.perPageDropdown.push(500);
            this.serverParams.perPageDropdown.push('All');
            let userId = JSON.parse(localStorage.getItem('user_obj'))['id'];

            if (userId > 0) {
                self.loginUserId = userId;
            }
            //self.selectedRows = self.$refs["listAuditInventory"].selectedRows.length;
            self.loadAuditInventory(false);

            /* setTimeout(function(){
                var stickyTop12 = 77;
                $(window).scroll(function () {
                    var windowTop = $(window).scrollTop();
                    var el = $('.admin-page-content');
                    if (el.length > 0) {
                        if (stickyTop12 < windowTop && !el.is('.sticky') && $(el).outerHeight() > ($(window).height() - 235)) {
                            el.addClass('sticky');
                            $('.dashboard .admin-page-content.sticky .vgt-responsive').height($(window).height() - 360);
                            $('#page-content-wrapper').addClass('sticky-footer');
                        }
                        else if (stickyTop12 > windowTop && el.is('.sticky')) {
                            el.removeClass('sticky');
                            $('.dashboard .admin-page-content .vgt-responsive').removeAttr('style');
                            $('#page-content-wrapper').removeClass('sticky-footer');
                        }
                    }
                });
            },500); */
        },

        methods: {
            changeDatePickerDate : function () {
              // self.datePickerError = '';   
            },
            clearFilter() {
                self.date_picker_dates.start = '';
                self.date_picker_dates.end = '';
                self.loadAuditInventory(false);
            },
            jumpToPageInTask: function (e) {
                self.jumpToInputPageTask(self.jumpToPageTask);
            },
            changedValueTaskCustomPerPageTask: function () {
                self.jumpToInputPageTask(self.serverParams.page);
                self.loadAuditInventory(false);
            },
            changedValueTask: function (value) {
                /*console.log(value);*/
            },
            pageNumberListTask: function () {
                var totalRecord = self.totalRecords;
                var count = 0;
                for (var i = 0; totalRecord > 0; i++) {
                    totalRecord = totalRecord - self.serverParams.perPage;
                    count++;
                }
                return count;
            },
            jumpToInputPageTask: function (pageNumber) {
                var reg = /^\d+$/;
                if (pageNumber <= 0 || pageNumber == '') {
                    pageNumber = 1;
                } else if (pageNumber > self.pageNumberListTask()) {
                    pageNumber = self.pageNumberListTask();
                    if (pageNumber <= 0 || pageNumber == '') {
                        pageNumber = 1;
                    }
                } else if (!String(self.jumpToPageTask).match(reg)) {
                    pageNumber = 1;
                }
                self.onPerticularPageClickTask(pageNumber);
            },
            onPerticularPageClickTask: function (pageNumber) {
                self.serverParams.page = pageNumber;
                self.jumpToPageTask = pageNumber;
                self.loadAuditInventory(false);
            },
            updateParams(newProps) {
                self.serverParams = Object.assign({}, self.serverParams, newProps);
            },
            //
            onPageChange(params) {
                self.updateParams({ page: params.currentPage });
                self.loadAuditInventory(false);
            },
            //
            onPerPageChange(params) {
                if (params.currentPerPage != self.serverParams.perPage) {
                    self.updateParams({ perPage: params.currentPerPage });
                    self.totalRecords = self.totalRecords;
                    self.loadAuditInventory(false);
                }
            },
            onColumnFilter(params) {
                self.updateParams(params);
                {
                    field: "id";
                    field: "user_name";
                    field: "customer_name";
                    field: "inventory_name";
                    field: "qty";
                    field: "updated_at";
                }
                self.serverParams.page = 1;
                var filtersPr = JSON.parse(JSON.stringify(self.serverParams));
                var filters = filtersPr.columnFilters;

                if (
                    self.firstLoad == 1 ||
                    filters.id ||
                    filters.user_name ||
                    filters.customer_name ||
                    filters.inventory_name ||
                    filters.qty ||
                    filters.updated_at
                ) {
                    self.loadAuditInventory(false);
                }
            },
            selectionChanged() {
                self.selectedRows = self.$refs["listAuditInventory"].selectedRows.length;
                /*console.log(self.selectedRows);*/
            },
            onSortChange(params) {
                self.updateParams({
                    sort: {
                        type: params[0].type,
                        field: params[0].field
                    }
                });
                self.loadAuditInventory(false);
            },
            loadAuditInventory: function(isExport) {
                self.storeFilters('adminAuditDate', self.date_picker_dates, false);
                self.storeFilters('adminauditlist', self.serverParams, false);
                self.firstLoad = 1;
                if (self.date_picker_dates.end === null) {
                  self.date_picker_dates.end = self.date_picker_dates.start;
                }
                var newPage = Math.ceil(self.totalRecords / self.serverParams.perPage);
                if (newPage) {
                    if (newPage < self.serverParams.page) {
                        self.serverParams.page = newPage;
                    }
                }
                var config = {
                    headers: {
                        Authorization:localStorage.getItem("access_token")
                    },
                    params : {
                        isExport: isExport,
                        page: self.serverParams.page,
                        perPage: self.serverParams.perPage,
                        filters: self.serverParams.columnFilters,
                        messageData: self.message,
                        sort: self.serverParams.sort,
                        tz: moment.tz.guess(),
                        /* from_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.start).format("YYYY-MM-DD") : "",
                        to_date: self.date_picker_dates.start != "" ? moment(self.date_picker_dates.end).format("YYYY-MM-DD") : "", */
                        from_date: "",
                        to_date: "",
                    }
                };
                HTTP.get("/audit/inventory/list", config)
                    .then(function(response) {
                        if (response.data.code == "200") {
                            if(response.data.message == "success export") {
                            	location.href = response.data.content;
                          	} else {
                                self.rows = response.data.content.row;
                                self.totalRecords = response.data.content.totalRecords;
                                self.paginationDisplayRowsTask = self.getRecords(self.serverParams.page, self.serverParams.perPage, self.totalRecords);
                            }
                        }
                    })
                    .catch(function(err) {
                        console.log('err', err)
                        if (err.response.status == 0) {
                            self.error = "Remote server can not be reachable";
                        } else {
                            //redirect to login page if user not authenticated
                            if (err.response.status == 401) {
                                //clear previous data
                                localStorage.removeItem("user_obj");
                                localStorage.removeItem("api_token");
                                localStorage.removeItem("profile_image");
                                //EventBus.$emit("logged-in", true, "", "");
                                //self.$router.push("/login");
                            }
                            self.error = err.response.data.message;
                        }
                    });
            }
        }
    };

    EventBus.$on("role", function(isLogin, roleId, roleName) {
        if (typeof self != "undefined") {
            self.roleId = roleId;
        }
    });

    EventBus.$on("permissions", function(isLogin, permissionArray) {
        if (typeof self != "undefined") {
            self.permissionsArray = [];
            for (var i = 0; i < permissionArray.length; i++) {
                self.permissionsArray.push(permissionArray[i].name);
            }
        }
    });
</script>



// WEBPACK FOOTER //
// src/components/AuditInventoryMaster/ListAuditInventory.vue